/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venuenameoptional2Inputs */

const en_venuenameoptional2 = /** @type {(inputs: Venuenameoptional2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue Name (Optional)`)
};

const de_venuenameoptional2 = /** @type {(inputs: Venuenameoptional2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort (optional)`)
};

/**
* | output |
* | --- |
* | "Venue Name (Optional)" |
*
* @param {Venuenameoptional2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venuenameoptional2 = /** @type {((inputs?: Venuenameoptional2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venuenameoptional2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venuenameoptional2(inputs)
	return de_venuenameoptional2(inputs)
});
export { venuenameoptional2 as "venueNameOptional" }